import { useQuery } from '@tanstack/react-query';

import { getArticleOnceApi, getArticlesApi, getArticleTagsApi } from '../api';

export const articlePageQueryKeys = {
  all: ['articles'] as const,
  page: (tags?: string[]) =>
    [...articlePageQueryKeys.all, 'page', { tags }] as const,
  pageOnce: (slug: string) =>
    [...articlePageQueryKeys.all, 'article-once', { slug }] as const,
  tags: () => [...articlePageQueryKeys.all, 'tags'] as const,
};

export const useArticlesData = (tags?: string[]) => {
  return useQuery({
    queryKey: articlePageQueryKeys.page(tags),
    queryFn: () => getArticlesApi(tags),
    placeholderData: (previousData) => previousData,
  });
};

export const useArticleOnceData = (slug: string) => {
  return useQuery({
    queryKey: articlePageQueryKeys.pageOnce(slug),
    queryFn: () => getArticleOnceApi(slug),
    placeholderData: (previousData) => previousData,
  });
};

export const useArticleTagsData = () => {
  return useQuery({
    queryKey: articlePageQueryKeys.tags(),
    queryFn: () => getArticleTagsApi(),
    placeholderData: (previousData) => previousData,
  });
};
